/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Cargo_PlaceholderInputs */

const en_select_cargo_placeholder = /** @type {(inputs: Select_Cargo_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select cargo...`)
};

const es_select_cargo_placeholder = /** @type {(inputs: Select_Cargo_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona una carga...`)
};

/**
* | output |
* | --- |
* | "Select cargo..." |
*
* @param {Select_Cargo_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const select_cargo_placeholder = /** @type {((inputs?: Select_Cargo_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Cargo_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_cargo_placeholder(inputs)
	return es_select_cargo_placeholder(inputs)
});